<template>
  <Flex direction="column">
    <BaseCheckbox
      v-model="enabled"
      :label="$t('employee.profile.show_in_booking_widget')"
    />
    <BaseInput
      v-model="description"
      :label="$t('employee.profile.about')"
      type="textarea"
    />
    <BaseInput
      v-model="jobTitle"
      :label="$t('employee.profile.job_title')"
    />
    <Languages v-model="languages" />
    <Portfolio v-model="portfolio" />
  </Flex>
</template>

<script
  setup
  lang="ts"
>
import type { LanguageEntryAttributes } from '@/types';
import Languages from './languages/index.vue';
import Portfolio from './Portfolio.vue';

const props = defineProps<{
  enabled: boolean;
  description: string | null;
  jobTitle: string | null;
  languages: LanguageEntryAttributes[];
  portfolio: string[];
}>();

const emit = defineEmits([
  'update:enabled',
  'update:description',
  'update:languages',
  'update:jobTitle',
  'update:portfolio',
]);

const enabled = computed({
  get: () => props.enabled,
  set: (value: boolean) => emit('update:enabled', value),
});

const description = computed({
  get: () => props.description,
  set: (value: string) => emit('update:description', value),
});

const languages = computed({
  get: () => props.languages,
  set: (value: string[]) => emit('update:languages', value),
});

const jobTitle = computed({
  get: () => props.jobTitle,
  set: (value: string) => emit('update:jobTitle', value),
});

const portfolio = computed({
  get: () => props.portfolio,
  set: (value: string[]) => emit('update:portfolio', value),
});
</script>
